module.exports = __webpack_public_path__ + "static/img/c1.f4ef8a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/pit/laboratory/c1.png
// module id = KuO2
// module chunks = 0